import { Header, FloatingSocials } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Services } from "@/components/landing/Services";
import { Packages } from "@/components/landing/Packages";
import { Gallery } from "@/components/landing/Gallery";
import { WhyParth } from "@/components/landing/WhyParth";
import { Process } from "@/components/landing/Process";
import { Reviews } from "@/components/landing/Reviews";
import { ServiceArea } from "@/components/landing/ServiceArea";
import { Faq } from "@/components/landing/Faq";
import { ContactSection } from "@/components/landing/ContactSection";
import { Footer } from "@/components/landing/Footer";

export default function Home() {
  return (
    <div className="bg-stone-50 text-stone-900 antialiased min-h-screen selection:bg-amber-200 selection:text-stone-900" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <Packages />
        <Gallery />
        <WhyParth />
        <Process />
        <Reviews />
        <ServiceArea />
        <Faq />
        <ContactSection />
      </main>
      <Footer />
      <FloatingSocials />
    </div>
  );
}
